import { useSession as useNextAuthSession } from 'next-auth/react';
import { useMemo, useRef, useEffect, useState } from 'react';

// Singleton to track session state
let sessionInstance: any = null;
let lastSessionUpdate = 0;

export function useSessionStable() {
  const { data: session, status, update } = useNextAuthSession();
  const [stableSession, setStableSession] = useState(session);
  const [stableStatus, setStableStatus] = useState(status);
  const updateTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Only update if session actually changed
  useEffect(() => {
    const now = Date.now();
    if (session && (!sessionInstance || sessionInstance.user?.id !== session.user?.id)) {
      sessionInstance = session;
      lastSessionUpdate = now;
      setStableSession(session);
    }
  }, [session]);

  useEffect(() => {
    setStableStatus(status);
  }, [status]);

  // Debounced update with cooldown
  const stableUpdate = () => {
    const now = Date.now();
    if (now - lastSessionUpdate < 10000) { // 10 second cooldown
      return;
    }

    if (updateTimeoutRef.current) {
      clearTimeout(updateTimeoutRef.current);
    }

    updateTimeoutRef.current = setTimeout(() => {
      lastSessionUpdate = now;
      update();
    }, 2000);
  };

  // Cleanup
  useEffect(() => {
    return () => {
      if (updateTimeoutRef.current) {
        clearTimeout(updateTimeoutRef.current);
      }
    };
  }, []);

  return {
    data: stableSession,
    status: stableStatus,
    update: stableUpdate,
  };
} 